import { render, staticRenderFns } from "./ByWeekPanel.vue?vue&type=template&id=37d52df2&"
import script from "./ByWeekPanel.vue?vue&type=script&lang=js&"
export * from "./ByWeekPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports